import { useI18n } from '@ah/i18n';
import { useLandingContent } from './useLandingContent';
import { CrisisBar } from './CrisisBar';

/**
 * Mounts the crisis line above every route (brief §1).
 *
 * It lives in the router rather than in each page so that a page added later
 * is covered by default — the one place this must never be forgotten is the
 * page nobody remembered to check. Content comes from the same CMS section as
 * the landing, and `readSection` re-locks it on the way through, so a bad draft
 * cannot empty the numbers.
 */
export function GlobalCrisisBar() {
  const { locale } = useI18n();
  const content = useLandingContent(locale);
  return <CrisisBar content={content.crisis_bar} />;
}
